import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

interface Props {
  title: string;
  price?: string;
}

const formatPrice = (price?: string): string | null => {
  if (!price) return null;

  const numericPrice = parseFloat(price);
  if (isNaN(numericPrice)) return price;

  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numericPrice);
};

const VentureDetailsHeader = ({ title, price }: Props) => {
  const { ref, inView } = useInView({ threshold: 0.2 });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="flex flex-col mb-[7rem] overflow-hidden"
    >
      <motion.h1
        initial={{ opacity: 0, clipPath: "inset(0 100% 0 0)" }}
        animate={
          inView
            ? { opacity: 1, clipPath: "inset(0 0 0 0)" }
            : { opacity: 0, clipPath: "inset(0 100% 0 0)" }
        }
        transition={{ duration: 0.7, delay: 0.3 }}
        className="h5 text-white mb-[1.6rem]"
      >
        {title}
      </motion.h1>

      {price && (
        <motion.h3
          initial={{ opacity: 0, clipPath: "inset(0 0 0 100%)" }}
          animate={
            inView
              ? { opacity: 1, clipPath: "inset(0 0 0 0)" }
              : { opacity: 0, clipPath: "inset(0 0 0 100%)" }
          }
          transition={{ duration: 0.7, delay: 0.4 }}
          className="text-white"
        >
          {price ? formatPrice(price) : "Price not available"}
        </motion.h3>
      )}
    </motion.div>
  );
};

export default VentureDetailsHeader;
